import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { UserService } from '../../user/user.service';
import { EventService } from '../../event/event.service';

@Injectable()
export class RouteGuardService implements CanActivate {

  constructor(
    private user: UserService,
    private router: Router,
    private event: EventService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {

    return new Promise((resolve, reject) => {
      this.user.getUserInfo().subscribe(
        res => {
          if (res == true) {
            this.user.gdpr = true;
            resolve(true);
          } else {
            if (state.url === '/my-profile') {
              resolve(true);
            } else {
              resolve(false);
              this.router.navigate(['my-profile']);
            }
            if (res == "D") {
              this.user.gdpr = false;
              this.event.emit("trmCondBtn", "");
            } else {
              this.user.gdpr = true;
              this.event.emit("editBtn", "");
            }
          }
          //this.event.emit("updateProfileImage", res);
        },
        err => {
          resolve(false);
          this.router.navigate(['my-profile']);
        }
      )
    });
  }

}



// WEBPACK FOOTER //
// G:/UTL/Alumni/Alumni-ANG/src/app/services/route-guards/route-guard/route-guard.service.ts